/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Button_AnalyzingInputs */

const en_keyword_optimizer_button_analyzing = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const de_keyword_optimizer_button_analyzing = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const fr_keyword_optimizer_button_analyzing = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const es_keyword_optimizer_button_analyzing = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const it_keyword_optimizer_button_analyzing = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const nl_keyword_optimizer_button_analyzing = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const pl_keyword_optimizer_button_analyzing = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const fi_keyword_optimizer_button_analyzing = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const da_keyword_optimizer_button_analyzing = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const sv_keyword_optimizer_button_analyzing = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

/**
* | output |
* | --- |
* | "Analyzing..." |
*
* @param {Keyword_Optimizer_Button_AnalyzingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_button_analyzing = /** @type {((inputs?: Keyword_Optimizer_Button_AnalyzingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Button_AnalyzingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_button_analyzing(inputs)
	if (locale === "fr") return fr_keyword_optimizer_button_analyzing(inputs)
	if (locale === "es") return es_keyword_optimizer_button_analyzing(inputs)
	if (locale === "it") return it_keyword_optimizer_button_analyzing(inputs)
	if (locale === "nl") return nl_keyword_optimizer_button_analyzing(inputs)
	if (locale === "pl") return pl_keyword_optimizer_button_analyzing(inputs)
	if (locale === "fi") return fi_keyword_optimizer_button_analyzing(inputs)
	if (locale === "da") return da_keyword_optimizer_button_analyzing(inputs)
	if (locale === "sv") return sv_keyword_optimizer_button_analyzing(inputs)
	return en_keyword_optimizer_button_analyzing(inputs)
});